


































































import { Component, Prop, Vue } from "vue-property-decorator";
import _ from "lodash";

import { WorkshopService, QuestionnaireService, LookupsService } from "@/core/services";
import {
  InputFieldCpt,
  InputSelectCpt,
  SubmitButtonCpt,
  BaseInputComponent,
  BaseFormComponent,
} from "@/core/components/form";
import { SimpleLookupModel, WorkshopClientLookups, CompanyModel } from "@/core/models";

@Component({
  components: {
    InputFieldCpt,
    InputSelectCpt,
    SubmitButtonCpt,
  },
})
export default class EditClientFormCpt extends BaseFormComponent {
  @Prop({ default: false }) loading: boolean;
  @Prop() workshopId: number;
  @Prop() model: CompanyModel;

  isSubmitButtonDisabled = false;
  submitInProgress = false;

  lookups = {
    counties: [] as SimpleLookupModel[],
    sectors: [] as SimpleLookupModel[],
  } as WorkshopClientLookups;

  async onSubmitForm() {
    await WorkshopService.postWorkshopClient(this.workshopId, this.model);
    this.model.countyName = LookupsService.findLookupText(this.lookups.counties, this.model.countyId);
    this.model.companySectorName = LookupsService.findLookupText(this.lookups.sectors, this.model.companySectorId);
    this.$emit("onSave", this.model);
  }

  async created() {
    await this.initializeLookups();
  }
  private async initializeLookups() {
    const lookups = await WorkshopService.getWorkshopClientLookups();
    _.extend(this.lookups, lookups);
  }
}
